import { useTranslation } from "react-i18next"

const OrderNotFound = () => {
  const { t } = useTranslation()

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-4">{t("order.not_found", "Order Not Found")}</h2>
        <p className="mb-6">
          {t("order.not_found_message", "We couldn't find your order. Please try registering again.")}
        </p>
        <button className="bg-theme_accent text-theme_text_light px-6 py-2 rounded-md hover:bg-theme_accent_light">
          {t("order.register_now", "Register Now")}
        </button>
      </div>
    </div>
  )
}

export { OrderNotFound }
